import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import "./App.css";
import FooterComponent from "./components/footer/FooterComponent";
import HeaderComponent from "./components/HeaderComponent";
import LandingPage from "./pages/landing.page";
import LayoutProvider from "./providers/layout.provider";

function App() {
  return (
    <LayoutProvider>
      <Router>
        <HeaderComponent />

        <Switch>
          <Route path="/">
            <LandingPage />
          </Route>
        </Switch>

        <FooterComponent />
      </Router>
    </LayoutProvider>
  );
}

export default App;
